import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../../../features/events/redux/actions';
import { iconForField } from '../../../../common/custom/icon-library';
import history from '../../../../common/history';
import { validateSubmitBtn } from '../../ActionFormUtils';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import BrowserStorageOptions from '../BrowserStorageOptions';
import ConsoleLogOptions from '../../ConsoleLogOptions';
class CollectionActionForm extends Component {
  state = {
    pageContent: {},
    pageId: '',
    roles: [],
    showBSLOption: false,
    showCLOption: false,
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      if (dbParameters) {
        schema[args.name] = dbParameters ? dbParameters.value : '';
      } else {
        schema[args.name] = args.value || '';
      }
    });
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, version, projectId, actions, selectedEvent } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  collectionOptions = () => {
    let options = [];
    let collections = this.props.events.collections;
    if (collections && collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };
  collectionRequestOptions = () => {
    let options = [
      { value: 'Secured', label: 'Secured (LoggedIn User)' },
      { value: 'Open', label: 'Open (Non-LoggedIn User)' },
    ];
    return options;
  };
  constructorOptions = (collectionName) => {
    let options = [];
    let collections = this.props.events.collections;
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionName,
    );
    let constructors = selectedCollection ? selectedCollection.constructors : [];
    if (constructors && constructors.length > 0) {
      options = options.concat(
        constructors.map((constructor) => {
          return { value: constructor.uuid, label: constructor.customConstructorName };
        }),
      );
    }
    return options;
  };
  browserStorageLocationOptions = () => {
    let options = [
      { value: 'SESSION_STORAGE', label: 'Session Storage (Default)' },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
      { value: 'INDEXED_DB', label: 'IndexedDB' },
    ];
    return options;
  };

  closeAllOpenPopup = () => {
    const { actions, projectId, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/2.0/collections/${version}/v/${projectId}/create`);
  };

  validateFormDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateFormDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  bslOptionHandler = () => {
    this.setState({
      showBSLOption: !this.state.showBSLOption,
    });
  };

  clogOptionHandler = () => {
    this.setState({
      showCLOption: !this.state.showCLOption,
    });
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { name } = eventAction;
    const { showBSLOption, showCLOption } = this.state;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, isValidating }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <a
                    onClick={this.closeAllOpenPopup}
                    className="direction-custom-link btn btn-outline-info"
                    title="Create Collection"
                  >
                    <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
                  </a> */}
                  <div className="input-group">
                    <div className="input-group-prepend" title="Choose Collection">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <CustomSelect
                      name={'collection'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.collectionOptions()}
                      value={values['collection']}
                      onChangeValue={this.handleChange}
                      placeholder={
                        ['saveCollection', 'saveCollectionDraft'].includes(name)
                          ? 'Select Collection'
                          : 'Select Collection (Optional)'
                      }
                    />
                  </div>
                  <small style={{ paddingLeft: '8%' }}>
                    Select a collection in which data should be{' '}
                    {['saveCollection', 'saveCollectionDraft'].includes(name) ? 'saved' : 'updated'}
                    .
                  </small>
                  <ErrorMessage name="collection" component="p" className="text-error ml-5" />
                </div>

                {values['collection'] ? (
                  <div className="form-group">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Choose Constructor">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                          <span className="required"> *</span>
                        </span>
                      </div>
                      <CustomSelect
                        name={'constructor'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.constructorOptions(values['collection'])}
                        value={values['constructor']}
                        placeholder={'Select Constructor (Optional)'}
                      />
                    </div>
                    <small style={{ paddingLeft: '8%' }}>
                      Select a constructor to set a default value if left empty.
                    </small>
                    <ErrorMessage name="constructor" component="p" className="text-error ml-5" />
                  </div>
                ) : (
                  ''
                )}

                {(['saveCollection', 'saveCollectionDraft'].includes(name) &&
                  values['collection']) ||
                ['updateCollection', 'updateCollectionDraft'].includes(name) ? (
                  <div className="form-group">
                    <div className="input-group">
                      <div className="input-group-prepend" title="Choose Request Type">
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('select')}`}></i>
                          <span className="required"> *</span>
                        </span>
                      </div>
                      <CustomSelect
                        name={'collectionRequest'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.collectionRequestOptions()}
                        value={values['collectionRequest']}
                        placeholder={'Select Request Type (Optional)'}
                      />
                    </div>
                    <small style={{ paddingLeft: '8%' }}>
                      Select the type of users to whom you allow adding new data to collection .
                    </small>
                    <ErrorMessage
                      name="collectionRequest"
                      component="p"
                      className="text-error ml-5"
                    />
                  </div>
                ) : (
                  ''
                )}
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Success Message">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Success Message"
                    />
                  </div>
                  <ErrorMessage name="successMessage" component="p" className="text-error ml-5" />
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Error Message">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="errorMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Error Message"
                    />
                  </div>
                  <ErrorMessage name="errorMessage" component="p" className="text-error ml-5" />
                </div>
                <div className="form-group">
                  <button
                    onClick={(e) => this.bslOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-5 p-1"
                    title="Show Browser Storage Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                  </button>
                  <button
                    onClick={(e) => this.clogOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-2 p-1"
                    title="Show Console Log Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
                  </button>
                </div>

                {/* {showBSLOption && (
                  <div style={{ marginLeft: '30px' }}>
                    <div className="form-group">
                      <div className="input-group">
                        <div
                          className="input-group-prepend"
                          title="Save Form Submission Data In Browser Session Storage"
                        >
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                          </span>
                        </div>
                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="passPreviousActionFormData"
                              className="form-check-input"
                              title="passPreviousActionFormData"
                            />
                            Save Form Submission Data In Browser Storage
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                        </div>
                        <TooltipInfo
                          title={`Enable it to save form submission data in your web browser storage.`}
                          headerText={`What's this ?`}
                          showHeader={true}
                          showArrow={true}
                          append={true}
                        />
                      </div>
                      <ErrorMessage
                        name="passPreviousActionFormData"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                    {values['passPreviousActionFormData'] && (
                      <>
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend" title="Form Data Session Key">
                              <span className="input-group-text">
                                <i className={`wb ${iconForField('text')}`}></i>
                                <span className="required"> *</span>
                              </span>
                            </div>
                            <Field
                              type="text"
                              name="formDataSessionKey"
                              className="form-control form-control-sm"
                              autoComplete="off"
                              placeholder="Form Data Session Key"
                              validate={this.validateFormDataSessionKey}
                            />
                            <TooltipInfo
                              title={`Enter the key in which you want to save form submission data in your web browser storage.`}
                              headerText={`What's this ?`}
                              showHeader={true}
                              showArrow={true}
                              append={true}
                            />
                          </div>
                          <ErrorMessage
                            name="formDataSessionKey"
                            component="p"
                            className="text-error ml-5"
                          />
                        </div>
                        <div className="form-group">
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              title="Session Storage Location (Optional)"
                            >
                              <span className="input-group-text">
                                <i className={`wb ${iconForField('select')}`}></i>
                                <span className="required"> *</span>
                              </span>
                            </div>
                            <CustomSelect
                              name={'formDataBrowserStorageLocation'}
                              isMulti={false}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              options={this.browserStorageLocationOptions()}
                              value={values['formDataBrowserStorageLocation']}
                              placeholder={'Session Storage Location (Optional)'}
                            />
                            <TooltipInfo
                              title={`Select the browser storage location where you want to set the key:value data in your web browser storage.`}
                              headerText={`What's this ?`}
                              showHeader={true}
                              showArrow={true}
                              append={true}
                            />
                          </div>
                          <small style={{ paddingLeft: '12%' }}>
                            Select a browser storage location to set a value (Default: Session
                            Storage).
                          </small>
                          <ErrorMessage
                            name="formDataBrowserStorageLocation"
                            component="p"
                            className="text-error ml-5"
                          />
                        </div>
                      </>
                    )}
                    <div className="form-group">
                      <div className="input-group">
                        <div
                          className="input-group-prepend"
                          title="Save Response Data In Browser Session Storage"
                        >
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                          </span>
                        </div>
                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="passPreviousActionResponse"
                              className="form-check-input"
                              title="passPreviousActionResponse"
                            />
                            Save Response Data In Browser Storage
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                        </div>
                        <TooltipInfo
                          title={`Enable it to save action response data in your web browser storage.`}
                          headerText={`What's this ?`}
                          showHeader={true}
                          showArrow={true}
                          append={true}
                        />
                      </div>
                      <ErrorMessage
                        name="passPreviousActionResponse"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                    {values['passPreviousActionResponse'] && (
                      <>
                        <div className="form-group">
                          <div className="input-group">
                            <div className="input-group-prepend" title="Response Data Session Key">
                              <span className="input-group-text">
                                <i className={`wb ${iconForField('text')}`}></i>
                                <span className="required"> *</span>
                              </span>
                            </div>
                            <Field
                              type="text"
                              name="responseDataSessionKey"
                              className="form-control form-control-sm"
                              autoComplete="off"
                              placeholder="Response Data Session Key"
                              validate={this.validateResponseDataSessionKey}
                            />
                            <TooltipInfo
                              title={`Enter the key in which you want to save response data in your web browser storage.`}
                              headerText={`What's this ?`}
                              showHeader={true}
                              showArrow={true}
                              append={true}
                            />
                          </div>
                          <ErrorMessage
                            name="responseDataSessionKey"
                            component="p"
                            className="text-error ml-5"
                          />
                        </div>
                        <div className="form-group">
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              title="Session Storage Location (Optional)"
                            >
                              <span className="input-group-text">
                                <i className={`wb ${iconForField('select')}`}></i>
                                <span className="required"> *</span>
                              </span>
                            </div>
                            <CustomSelect
                              name={'responseDataSessionStorageLocation'}
                              isMulti={false}
                              onChange={setFieldValue}
                              onBlur={setFieldTouched}
                              options={this.browserStorageLocationOptions()}
                              value={values['responseDataSessionStorageLocation']}
                              placeholder={'Session Storage Location (Optional)'}
                            />
                            <TooltipInfo
                              title={`Select the browser storage location where you want to set the key:value data in your web browser storage.`}
                              headerText={`What's this ?`}
                              showHeader={true}
                              showArrow={true}
                              append={true}
                            />
                          </div>
                          <small style={{ paddingLeft: '12%' }}>
                            Select a browser storage location to set a value (Default: Session
                            Storage).
                          </small>
                          <ErrorMessage
                            name="responseDataSessionStorageLocation"
                            component="p"
                            className="text-error ml-5"
                          />
                        </div>
                      </>
                    )}
                  </div>
                )} */}

                {showBSLOption && (
                  <BrowserStorageOptions
                    values={values}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    validateFormDataSessionKey={this.validateFormDataSessionKey}
                    validateResponseDataSessionKey={this.validateResponseDataSessionKey}
                  />
                )}
                {showCLOption && <ConsoleLogOptions values={values} />}

                {['saveCollectionDraft', 'updateCollectionDraft'].includes(name) ? (
                  <div className="form-group">
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        title={`Reset Form Data On ${
                          name === 'saveCollectionDraft' ? 'Save' : 'Update'
                        }`}
                      >
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                        </span>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <Field
                            type="checkbox"
                            name="resetFormData"
                            className="form-check-input"
                            title="resetFormData"
                          />
                          Reset Form Data On {name === 'saveCollectionDraft' ? 'Save' : 'Update'}
                          <span className="form-check-sign">
                            <span className="check"></span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <ErrorMessage name="resetFormData" component="p" className="text-error ml-5" />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button
                  type="submit"
                  disabled={validateSubmitBtn(values, eventAction)}
                  className={`btn btn-sm ${
                    validateSubmitBtn(values, eventAction) ? 'btn-default' : 'btn-theme-submit'
                  }`}
                >
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionActionForm);
